import { useProvideSnackBar } from './useSnackBar';
import { usePreconfiguredFetch } from './useProvidePreconfiguredFetch';
import { useEffect, useState } from 'react';
import { Partner } from '../@types/workplace';

export const usePartnerList = () => {
    const { showError } = useProvideSnackBar();
    const { fetchResource } = usePreconfiguredFetch();
    const [partnerList, setPartnerList] = useState<Partner[]>([]);

    useEffect(() => {
        const fetchPartnerList = async () => {
            const resp = await fetchResource('/api/partners');

            if (resp.status === 200) {
                const partnerList: Partner[] = await resp.json();

                for (const partner of partnerList) {
                    if (!partner.Name || partner.Name.trim().length === 0) {
                        showError("Hiányzó partnernév");
                        return;
                    }
                    if (!partner.ID || partner.ID === 0) {
                        showError("Hiányzó partner azonosító");
                        return;
                    }
                }

                setPartnerList(partnerList.sort((a: Partner, b: Partner) => a.Name.localeCompare(b.Name)));
                return;
            }

            if (resp.status === 401) {
                showError('A munkamenet lejárt, kérjük jelentkezzen be újra!');
                return;
            }

            showError('Hiba a partner lista lekérése közben!');
        };

        fetchPartnerList();
    }, []);

    return {
        partnerList,
    };
};
